import { useId } from "react";

export const LogoMark = ({ size = 36 }) => {
  const gid = "lg" + useId().replace(/[^a-zA-Z0-9]/g, "");
  return (
  <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
    <defs>
      <linearGradient id={gid} x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#FDE68A" />
        <stop offset=".5" stopColor="#D4AF37" />
        <stop offset="1" stopColor="#92400E" />
      </linearGradient>
    </defs>
    <rect width="64" height="64" rx="14" fill="#09090B" />
    <rect x="3" y="3" width="58" height="58" rx="12" fill="none" stroke={`url(#${gid})`} strokeWidth="2" />
    <text x="32" y="41" textAnchor="middle" fontFamily="Cabinet Grotesk, Arial Black, sans-serif" fontWeight="800" fontSize="24" fill={`url(#${gid})`}>RS</text>
    <path d="M46 14l2 4 4 2-4 2-2 4-2-4-4-2 4-2z" fill="#FDE68A" />
  </svg>
  );
};

export const Logo = ({ size = 36, compact = false }) => (
  <div className="flex items-center gap-2.5" data-testid="brand-logo">
    <LogoMark size={size} />
    {!compact && (
      <div className="leading-tight">
        <div className="font-display font-extrabold text-white text-lg tracking-tight">RS Achadinhos</div>
        <div className="text-[9px] font-bold tracking-[0.12em] gold-text whitespace-nowrap">INTELIGÊNCIA ARTIFICIAL</div>
      </div>
    )}
  </div>
);
